var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-video',{attrs:{"is-playing":_vm.isPlaying}},[_c('source',{attrs:{"src":_vm.videoResource.src,"type":_vm.videoResource.type}})])}
var staticRenderFns = []

export { render, staticRenderFns }